import React from "react";
import PropTypes from "prop-types";
import {ExitToApp as SignOutIcon, Settings as SettingsIcon} from "@material-ui/icons";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import authLib from "../../../../lib/auth";
import LinkMenuItem from "../../components/LinkMenuItem";

export default class UserMenu extends React.Component {
  render() {
    return (
      <React.Fragment>
        <List>
          <LinkMenuItem
            to={`/account`}
            isActive={this.props.url.startsWith("/map")}
            primary={<p className="menuItemText">Settings</p>}
            iconLeft={<SettingsIcon className="sidebarIcon" />}
          />
          <Divider />
          <LinkMenuItem
            onClick={this.logOut}
            primary={<p className="menuItemText">Log Out</p>}
            iconLeft={<SignOutIcon />}
          />
        </List>
      </React.Fragment>
    );
  }

  logOut() {
    authLib.logOut();
  }
}

UserMenu.propTypes = {
  url: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menus/UserMenu/index.jsx